/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Retrieving_Latest_CommitInputs */

const en_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieving latest commit from server...`)
};

const fr_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération du dernier commit depuis le serveur...`)
};

const de_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rufe den neuesten Commit vom Server ab...`)
};

const it_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recupero dell'ultimo commit dal server...`)
};

const ru_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получение последнего коммита с сервера...`)
};

const es_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperando la última confirmación del servidor...`)
};

const zh_cn2_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在从服务器获取最新提交...`)
};

const ja_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーから最新のコミットを取得しています...`)
};

const hi_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सर्वर से नवीनतम कमिट प्राप्त किया जा रहा है...`)
};

const pt_pt2_team_sync_status_retrieving_latest_commit = /** @type {(inputs: Team_Sync_Status_Retrieving_Latest_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperando o último commit do servidor...`)
};

/**
* | output |
* | --- |
* | "Retrieving latest commit from server..." |
*
* @param {Team_Sync_Status_Retrieving_Latest_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_retrieving_latest_commit = /** @type {((inputs?: Team_Sync_Status_Retrieving_Latest_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Retrieving_Latest_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "de") return de_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "it") return it_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "ru") return ru_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "es") return es_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "ja") return ja_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "hi") return hi_team_sync_status_retrieving_latest_commit(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_status_retrieving_latest_commit(inputs)
	return en_team_sync_status_retrieving_latest_commit(inputs)
});